function AnalyticsIllustration() {
  const bars = [42, 68, 55, 82, 71, 95, 78, 88];
  const strategies = ['Scalp', 'Swing', 'Iron Condor', 'Breakout'];

  return (
    <div className="illus illus--analytics" aria-hidden="true">
      <div className="illus__window">
        <div className="illus__titlebar">
          <span />
          <span />
          <span />
          <span className="illus__titlebar-text">Estrategias · Win rate</span>
        </div>
        <div className="illus-chart">
          <div className="illus-chart__bars">
            {bars.map((height, i) => (
              <div
                key={i}
                className="illus-chart__bar"
                style={{ height: `${height}%` }}
              />
            ))}
          </div>
          <div className="illus-chart__labels">
            {strategies.map((label) => (
              <span key={label}>{label}</span>
            ))}
          </div>
        </div>
        <div className="illus-stats">
          <div className="illus-stat">
            <span className="illus-stat__value">68%</span>
            <span className="illus-stat__label">Win rate</span>
          </div>
          <div className="illus-stat">
            <span className="illus-stat__value illus-stat__value--accent">+$12.4k</span>
            <span className="illus-stat__label">Mejor mes</span>
          </div>
          <div className="illus-stat">
            <span className="illus-stat__value">Iron Condor</span>
            <span className="illus-stat__label">Top estrategia</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnalyticsIllustration;
